import {
    CUSTOM_SEGMENT_CREATED_UPDATED,
    DELETE_SEGMENT_GROUP_SUCCESS,
    GROUP_CREATED_UPDATED,
    GROUP_DELETED,
    RECEIVE_SEGMENTS_MODULE_META_DATA,
    REQUEST_SEGMENTS_MODULE_META_DATA,
    SHOW_NO_ACCESS_MODAL,
    TOGGLE_CREATE_UPDATE_SEGMENT_GROUP_MODAL,
    TOGGLE_DELETE_SEGMENT_GROUP_MODAL,
    SET_ENABLED_WIDGETS,
    RECEIVE_SEGMENTS_DASHBOARD_MODULE_META_DATA,
    UPDATE_UNIQUE_SEGMENTS_IDS,
} from "app/action_types/segments_module_action_types";
import type {
    DashboardSegmentsMeta,
    ICustomSegment,
    ICustomSegmentsGroup,
    ICustomSegmentsMetaData,
    UniqueSegments,
    WidgetAvailability,
} from "app/services/segments/segmentsApiService";

export const showNoAccessModal = (shouldShow: boolean) => {
    return {
        type: SHOW_NO_ACCESS_MODAL,
        shouldShowNoAccessModal: shouldShow,
    };
};

export const requestSegmentsModuleMeta = () => {
    return {
        type: REQUEST_SEGMENTS_MODULE_META_DATA,
        segmentsLoading: true,
    };
};

export const receiveSegmentsModuleMeta = (customSegmentsMeta: ICustomSegmentsMetaData) => {
    return {
        type: RECEIVE_SEGMENTS_MODULE_META_DATA,
        customSegmentsMeta,
        segmentsLoading: false,
    };
};

export const setEnabledWidgets = (segmentWidgetAvailability: WidgetAvailability) => {
    return {
        type: SET_ENABLED_WIDGETS,
        segmentWidgetAvailability,
    };
};

export const receiveSegmentsDashboardModuleMeta = (dashboardSegmentsMeta: DashboardSegmentsMeta) => ({
    type: RECEIVE_SEGMENTS_DASHBOARD_MODULE_META_DATA,
    dashboardSegmentsMeta,
    segmentsLoading: false,
});

export const updateUniqueSegmentsIds = (uniqueSegments: UniqueSegments) => ({
    type: UPDATE_UNIQUE_SEGMENTS_IDS,
    uniqueSegments,
});

export const toggleCreateUpdateSegmentGroupModal = (
    isOpen: boolean,
    segmentGroup?: ICustomSegmentsGroup,
    segmentToCompare?: string,
) => {
    return {
        type: TOGGLE_CREATE_UPDATE_SEGMENT_GROUP_MODAL,
        isOpen,
        segmentGroup,
        segmentToCompare,
    };
};

export const toggleDeleteSegmentGroupModal = (isOpen: boolean, segmentGroup?: ICustomSegmentsGroup) => {
    return {
        type: TOGGLE_DELETE_SEGMENT_GROUP_MODAL,
        isOpen,
        segmentGroup,
    };
};

export const deleteSegmentGroupSuccess = (segmentGroup: ICustomSegmentsGroup) => {
    return {
        type: DELETE_SEGMENT_GROUP_SUCCESS,
        segmentGroup,
    };
};

export const groupCreatedUpdated = (segmentGroup: ICustomSegmentsGroup) => {
    return {
        type: GROUP_CREATED_UPDATED,
        segmentGroup,
    };
};

const groupDeleted = (segmentGroupId: string) => {
    return {
        type: GROUP_DELETED,
        segmentGroupId,
    };
};

export const customSegmentCreatedUpdated = (customSegment: ICustomSegment) => {
    return {
        type: CUSTOM_SEGMENT_CREATED_UPDATED,
        customSegment,
    };
};
